"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _Skeleton = _interopRequireDefault(require("@material-ui/lab/Skeleton"));
var _clsx = _interopRequireDefault(require("clsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _core.makeStyles)(theme => ({
  image: {
    display: "block",
    objectFit: "cover",
    opacity: 1,
    transition: theme.transitions.create(["opacity"])
  },
  imageSize: {
    height: "100%",
    width: "100%"
  },
  placeholder: {
    background: "rgba(255, 255, 255, 0.8)"
  },
  logo: {
    display: "block",
    left: "50%",
    maxHeight: 180,
    maxWidth: "50%",
    position: "absolute",
    top: "50%",
    transform: "translate(-50%, -50%)",
    visibility: "visible"
  },
  notLoaded: {
    opacity: 0
  }
}));
const Image = _ref => {
  let {
    filename,
    alt = "",
    height,
    width,
    fixed = false,
    itemStyle = ""
  } = _ref;
  const {
    PUBLIC_URL,
    REACT_APP_LOGOAPPINFO
  } = process.env;
  const [loaded, setLoaded] = (0, _react.useState)(false);
  const css = useStyles();
  const handleLoad = () => {
    setLoaded(true);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (!loaded || !filename) && /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
    animation: "wave",
    className: css.placeholder,
    variant: "rect",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: css.logo,
    src: PUBLIC_URL + "/img/" + REACT_APP_LOGOAPPINFO,
    alt: alt
  })), filename && /*#__PURE__*/_react.default.createElement("img", {
    className: (0, _clsx.default)({
      [itemStyle]: true,
      [css.image]: true,
      [css.imageSize]: !fixed,
      [css.notLoaded]: !loaded
    }),
    alt: alt,
    height: height,
    loading: "lazy",
    src: filename,
    width: width,
    onLoad: () => handleLoad()
  }));
};
var _default = exports.default = Image;